import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Container, Row, Col, Card, CardHeader, CardTitle, CardBody, CardImg, CardImgOverlay, Jumbotron, ButtonGroup, Button, Alert } from 'reactstrap';
import FontAwesome from 'react-fontawesome';


function ErrorPage(props) {
    return (
        <Container className="mt-5 pt-5 text-center">
            <span className="d-block mb-3 display-2">Ooops !</span>
            <span className="d-block mb-3 display-4"><FormattedMessage id="Page404ErrorTitle" defaultMessage="We didn't find what you're looking for..." /></span>
            <ButtonGroup>
                <Button to="/" tag={Link} color="primary">
                    <FontAwesome name="home" /> <FormattedMessage id="appHome" defaultMessage="Home" />
                </Button>
                <Button to="/user/profile" tag={Link} color="success" outline>
                    <FontAwesome name="tachometer-alt" /> <FormattedMessage id="userAccountMy" defaultMessage="My account" />
                </Button>
            </ButtonGroup>
        </Container>
    );
}

export default injectIntl(ErrorPage);
